// extracted by mini-css-extract-plugin
export default {"gridContainer":"Platform_gridContainer__ed7zo","imageItem":"Platform_imageItem__kxqgb"};